import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { BalanceSheetStatementSchema } from "../../types"

type BalancesheetStatementType = {
  date_start: string
  location_id: string
}
export function useBalancesheetStatementList(params?: BalancesheetStatementType) {
  const api = useApi()
  const [data, setData] = useState<BalanceSheetStatementSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  const refetch = (params: BalancesheetStatementType): void => {
    setLoading(true)
    const isLocation = params.location_id !== "" ? params.location_id : null

    api.get("/dashboard/balance-sheet-statemenet/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: BalanceSheetStatementSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    const isLocation = params?.location_id !== "" ? params?.location_id : null
    setLoading(true)
  
    api.get("/dashboard/balance-sheet-statemenet/", { params: { ...params, location_id: isLocation }})
    .then((res: SuccessFetch<{ payload: BalanceSheetStatementSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data, isLoading, refetch }
}